import React from 'react';
import DetectTouch from '../partials/global/DetectTouch';
import ViewportFix from '../partials/global/ViewportFix';
import Cover from '../partials/global/Cover';
import Scrolled from '../partials/global/Scrolled';
import Header from '../partials/global/Header';
import Dot from '../partials/global/Dot';
import Page from '../partials/page/Page';
import ProjectTemplate from '../partials/projects/ProjectTemplate';
import Project from '../partials/project/Project';
import {Provider} from '../context/Context'

const TplIndex = (props) => {  
		
	let block = null;
	if (props.match.path === '/projects/:slug') {
		block = <ProjectTemplate></ProjectTemplate>;
	} else if (props.match.path === '/project/:slug') {
		block = <Project></Project>;
	} else if (props.match.path === '/:slug') {
		block = <Page></Page>;
	} else if (props.match.path === '/') {
		block = <Page></Page>;
	}
    
    if (block) {
		return (
			<Provider router={props}>
				<DetectTouch></DetectTouch>
				<ViewportFix></ViewportFix>
				<Cover></Cover>
				<Header></Header>
				{ block }
				<Scrolled></Scrolled>
			</Provider>
		)    
	} else {
		return null;
	}
}
export default TplIndex